/**
 * Індикатор стану зміни.
 *
 * Раніше стан зміни показувався словами «Зміна відкрита» посеред тулбара
 * і зникав узагалі, коли зміна була закрита — касир не бачив різниці між
 * «зміна закрита» і «застосунок ще не завантажив дані».
 */
const ShiftBadge = ({ open, onLight = false }) => (
    <span
        className={[
            'rc-shift-badge',
            open ? 'rc-shift-badge--open' : 'rc-shift-badge--closed',
            onLight ? 'rc-shift-badge--on-light' : '',
        ]
            .filter(Boolean)
            .join(' ')}
    >
        <span className="rc-shift-badge__dot" />
        {open ? 'Зміна відкрита' : 'Зміна закрита'}
    </span>
);

export default ShiftBadge;
